
export default {

  questionAddData: {
    formImportExcel: {},
    fileList: [], // excel文件列表
    txjy: false, // 题型下拉框禁用
    stid: '',
    options: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'],
    dynamicValidateForm: {
      domains: [{
        xxid: 1,
        xsxh: 1,
        value: '',
        xxnr: '',
        check: ''
      }, {
        xxid: 2,
        xsxh: 2,
        value: '',
        xxnr: '',
        check: ''
      }, {
        xxid: 3,
        xsxh: 3,
        value: '',
        xxnr: '',
        check: ''
      }, {
        xxid: 4,
        xsxh: 4,
        value: '',
        xxnr: '',
        check: ''
      }]
    },
    answerForm: {
      answers: [
        {
          xh: 1,
          value: '',
          scale: null,
          key: Date.now()
        }
      ]
    },
    radio: '',
    KsyStkStxxList: [],
    KsyStkDfdList: [],
    ksyStkStda: {},
    KsyStkDfdszList: [],
    commonForm: {},
    textAnswer: '',
    tg: '',
    stnr: '',
    jx: '',
    bfxh: '',
    judgeans: '',
    value: '',
    bzda: '',
    ksy_stk: {},
    dialogBatchVisible: false, // 批量添加选项输入框是否显示
    batch: '', // 批量添加选项
    zfbz: 0, // 简单题是否比例为100
    sfkbxx: 0 // 是否空白选项
  },
  pickerOptions: {
    // disabledDate (time) {
    //   return time.getTime() > Date.now()
    // },
    shortcuts: [{
      text: '今天',
      onClick (picker) {
        picker.$emit('pick', new Date())
      }
    }, {
      text: '昨天',
      onClick (picker) {
        const date = new Date()
        date.setTime(date.getTime() - 3600 * 1000 * 24)
        picker.$emit('pick', date)
      }
    }, {
      text: '一周前',
      onClick (picker) {
        const date = new Date()
        date.setTime(date.getTime() - 3600 * 1000 * 24 * 7)
        picker.$emit('pick', date)
      }
    }]
  },
  tabs: [
    { text: '试卷设计', type: 'paper', class01: 'g-tab-clicked' },
    { text: '考试设置', type: 'exam', class01: 'g-tab-unclicked' }
  ],
  tabs01: [
    { text: '试卷设计', type: 'paper', class01: 'g-tab-clicked' }
  ],
  tabs02: [
    { text: '手工录入', type: 'manual', class01: 'g-tab-clicked' },
    { text: '文本批量录入', type: 'text', class01: 'g-tab-unclicked' },
    { text: 'Excel批量导入', type: 'excel', class01: 'g-tab-unclicked' }
  ],
  tabs03: [
    { text: '手工录入', type: 'manual', class01: 'type-clicked' },
    { text: '文本批量录入', type: 'text', class01: 'type-unclicked' },
    { text: 'Excel批量导入', type: 'excel', class01: 'type-unclicked' }
  ],
  tagList: [
    {
      value: 'Beijing',
      label: '北京'
    }, {
      value: 'Shanghai',
      label: '上海'
    }, {
      value: 'Nanjing',
      label: '南京'
    }, {
      value: 'Chengdu',
      label: '成都'
    }, {
      value: 'Shenzhen',
      label: '深圳'
    }, {
      value: 'Guangzhou',
      label: '广州'
    }
  ]
}
